import React, { useState, useEffect } from 'react';
import fiorinaGionaImg from '../assets/cd_fiorina_giona.jpg';
import danilaGallottiImg from '../assets/Danila Gallotti Foto_Novembre2025.jpg';
import martelli_img from '../assets/Maurizio_Martelli.JPG';
import breccia_img from '../assets/Massimo_Breccia.png';
import barberi_img from '../assets/Walter_Barberi.jpg';
import montanari_img from '../assets/Marta_Montanari.jpg';
import palumbo_img from '../assets/Giovanna_Palumbo.png';
import annaTestiImg from '../assets/AnnaTesti Foto_Novembre 2025.JPG';
import CV_Maurizio_Martelli from '../assets/CV_Maurizio_Martelli.pdf';
import CV_Massimo_Breccia from '../assets/CV_Massimo_Breccia.pdf';
import CV_Walter_Barberi from '../assets/CV_Walter_Barberi.docx';
import CV_Giovanna_Palumbo from '../assets/CV_Giovanna_Palumbo.pdf';
import barbaraCavalloImg from '../assets/cd_barbara_cavallo.jpg';
import elisabettaGhirlandaImg from '../assets/cd_elisabetta_ghirlanda.jpeg';
import silviaFinocchiImg from '../assets/cd_silvia_finocchi.jpeg';
import statutoPdf from '../assets/ODV_STATUTO_DIGITALE_ROBIN_HOOD_ROMA.pdf';
import vademecumVolontarioPdf from '../assets/VADEMECUM_VOLONTARIO.pdf';

// Definizione del componente Modal per PDF
const PdfModal = ({ isOpen, onClose, title, pdfUrl }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out">
      <div
        className="bg-white rounded-lg shadow-xl w-full h-full max-w-6xl max-h-[90vh] mx-auto z-10 transform transition-all duration-300 ease-in-out flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-4 border-b flex items-center justify-between flex-shrink-0">
          <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label="Chiudi"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-1 overflow-hidden">
          <iframe
            src={pdfUrl}
            className="w-full h-full"
            title={title}
            style={{ border: 'none' }}
          />
        </div>
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-between items-center flex-shrink-0">
          <a
            href={pdfUrl}
            download="VADEMECUM_VOLONTARIO.pdf"
            className="bg-primary text-white py-2 px-4 rounded-lg font-semibold hover:bg-primary/90 transition duration-300"
          >
            Scarica PDF
          </a>
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-semibold hover:bg-gray-400 transition duration-300"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

// Definizione del componente Modal
const Modal = ({ isOpen, onClose, title, children }) => {
  // Sposta useEffect qui, prima dell'early return
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    // Aggiungi l'event listener solo se il modale è aperto
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }

    // La funzione di cleanup rimuoverà l'event listener
    // quando il componente viene smontato o prima che l'effetto venga rieseguito
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]); // Aggiungi isOpen alle dipendenze dell'effetto

  // L'early return rimane qui, dopo gli Hooks
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out">
      <div
        className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-auto z-10 transform transition-all duration-300 ease-in-out scale-95 group-hover:scale-100"
        onClick={(e) => e.stopPropagation()} // Impedisce la chiusura cliccando dentro il modale
      >
        <div className="px-6 py-4 border-b flex items-center justify-between">
          <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label="Chiudi"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-6 max-h-[60vh] overflow-y-auto">
          {children}
        </div>
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-semibold hover:bg-gray-400 transition duration-300"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

const ConsiglioDirectivo = () => {
  const [animatedItems, setAnimatedItems] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isVademecumModalOpen, setIsVademecumModalOpen] = useState(false);

  // Metodi per il download dei CV
  const handleDownloadCV = () => {
    const link = document.createElement('a');
    link.href = CV_Maurizio_Martelli;
    link.download = 'CV_Maurizio_Martelli.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadCV2 = () => {
    const link = document.createElement('a');
    link.href = CV_Massimo_Breccia;
    link.download = 'CV_Massimo_Breccia.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadCV3 = () => {
    const link = document.createElement('a');
    link.href = CV_Walter_Barberi;
    link.download = 'CV_Walter_Barberi.docx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadCV4 = () => {
    const link = document.createElement('a');
    link.href = CV_Giovanna_Palumbo;
    link.download = 'CV_Giovanna_Palumbo.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Add custom CSS for animations
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-15px); }
      }
      .animate-float {
        animation: float 6s ease-in-out infinite;
      }
      @keyframes pulse {
        0%, 100% { opacity: 0.1; }
        50% { opacity: 0.3; }
      }
      .animate-pulse {
        animation: pulse 4s ease-in-out infinite;
      }
      @keyframes slideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      .animate-slideUp {
        animation: slideUp 0.5s ease-out forwards;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setAnimatedItems(prev => [...prev, entry.target.id]);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll').forEach(item => {
      observer.observe(item);
    });

    return () => {
      document.querySelectorAll('.animate-on-scroll').forEach(item => {
        observer.unobserve(item);
      });
    };
  }, []);

  // Real data for board members
  const boardMembers = [
    {
      id: 1,
      name: 'Fiorina Giona',
      role: 'Presidente',
      bio: "Coordina le attività operative dell'associazione. Rapporti con le Istituzioni e con le altre Associazioni di volontariato",
      color: '#5AB45A',
      icon: 'M3 3h18v18H3V3zm9 4.5L7.5 12 12 16.5l4.5-4.5L12 7.5z',
      profileImage: fiorinaGionaImg,
      didascalia: 'Medico e ricercatore, ha dedicato la sua attività clinica e di ricerca alle patologie rare di interesse ematologico. La volontà di continuare ad occuparsi attivamente dei bisogni dei pazienti, dopo aver lasciato l’attività clinica, le ha fatto accettare l’incarico di portare avanti le iniziative di un’associazione nata “dai pazienti per i pazienti”. Contribuire a migliorare l’assistenza, supportare chi ha difficoltà a curarsi, unendo le forze con altri che condividono gli stessi ideali, sono modi per esprimere i propri valori e passioni.',
    },
    {
      id: 2,
      name: 'Danila Gallotti',
      role: 'Vicepresidente',
      bio: "Coordina le attività operative dell'associazione e supporta la Presidente nelle sue funzioni.",
      color: '#E63129',
      icon: 'M12 2L2 12h3v8h14v-8h3L12 2zm0 7.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z',
      profileImage: danilaGallottiImg,
      imagePosition: 'center 65%',
      didascalia: 'Dettagli aggiuntivi per Danila Gallotti saranno disponibili a breve.',
    },
    {
      id: 3,
      name: 'Elisabetta Ghirlanda',
      role: 'Tesoriere',
      bio: 'Responsabile del supporto amministrativo e gestionale dell\'Associazione e del rapporto con i soci',
      color: '#E63129',
      icon: 'M3.94 5.13l8.11 4.68c.05.03.1.05.15.05s.09-.02.14-.05l8.11-4.68a.46.46 0 00.04-.79L12.29.05a.46.46 0 00-.58 0L3.9 4.34a.46.46 0 00.04.79zm8.26 6.53l-6.48-3.75-2.68 1.55c-.28.16-.28.56 0 .72l8.11 4.68c.05.03.1.05.15.05s.09-.02.14-.05l8.11-4.68a.46.46 0 000-.72l-2.68-1.55-6.48 3.75a.46.46 0 01-.58 0zm0 4l-6.48-3.75-2.68 1.55c-.28.16-.28.56 0 .72l8.11 4.68c.05.03.1.05.15.05s.09-.02.14-.05l8.11-4.68a.46.46 0 000-.72l-2.68-1.55-6.48 3.75a.46.46 0 01-.58 0z',
      profileImage: elisabettaGhirlandaImg,
      didascalia: "Elisabetta Ghirlanda ha vissuto e lavorato a Roma. Raggiunto il traguardo della (tanto sospirata) pensione, ha deciso di dedicarsi al volontariato, perché spera che il suo «impegno all’interno dell’Associazione Robin Hood Roma ODV possa contribuire a dare una speranza a chi oggi non ce l'ha».",
    },
    {
      id: 4,
      name: 'Maria Barbara Cavallo',
      role: 'Segretario',
      bio: 'Responsabile del supporto giuridico',
      color: '#5AB45A',
      icon: 'M10 4h4v4h-4V4zm0 6h4v4h-4v-4zm-6-6h4v4H4V4zm0 6h4v4H4v-4z',
      profileImage: barbaraCavalloImg,
      didascalia: 'Maria Barbara Cavallo ha studiato Giurisprudenza ed è Magistrato Amministrativo. Si occupa degli aspetti giuridici della Robin Hood Roma ODV. «Metto a disposizione le mie competenze, perché solo così restituisco quello che ho ricevuto».',
    },
    {
      id: 6,
      name: 'Silvia Finocchi',
      role: 'Consigliere',
      bio: 'Coordinamento del gruppo per il benessere psicologico',
      color: '#E63129',
      icon: 'M2 2h5v5H2V2zm0 11h5v5H2v-5zm11 0h5v5h-5v-5zm0-11h5v5h-5V2z',
      profileImage: silviaFinocchiImg,
      didascalia: "Silvia Finocchi è psicologa e psicoterapeuta. Fa parte dell'associazione «Robin Hood Roma ODV» perché ritiene che «se non sempre si può alleviare la sofferenza, si può trasformarla in qualcosa di costruttivo per gli altri e per noi stessi».",
    }
  ];

  return (
    <>
      <div className="container mx-auto px-4 py-10 animate-on-scroll" id="organization-section">
        <h2 className={`text-3xl md:text-4xl font-bold text-center text-primary mb-6 ${animatedItems.includes('organization-section') ? 'animate-fadeIn' : 'opacity-0'}`}>
          Organizzazione dell’Associazione
        </h2>
        <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-10 rounded-full"></div>
        <div className={`text-xl text-gray-700 text-left mx-auto space-y-4 ${animatedItems.includes('organization-section') ? 'animate-slideUp delay-300' : 'opacity-0 translate-y-10'}`}>
          <p>
            L’Associazione, seguendo le regole del Codice del Terzo Settore, ha uno Statuto
            ( <a href={statutoPdf} download="Statuto_Robin_Hood_Roma_ODV.pdf" rel="noopener noreferrer" className="text-accent hover:underline font-medium">visualizza lo statuto</a> )
            e un Regolamento.
          </p>
          <p>
            Ha ottenuto dal RUNTS il riconoscimento della personalità giuridica, con provvedimento del 3 giugno 2024, Determinazione G06731.
          </p>
          <p>
            In considerazione delle sue caratteristiche, sono componenti essenziali dell’Associazione:
          </p>
          <ul className="list-disc list-inside space-y-2 text-left"> {/* Adjusted text alignment for list */}
            <li>L’Assemblea dei Soci, ordinari e sostenitori</li>
            <li>I Volontari</li>
            <li>Il Consiglio Direttivo</li>
            <li>Il Presidente</li>
            <li>Il Comitato scientifico</li>
          </ul>
        </div>
      </div>

      {/* Sezione I Volontari */}
      <div className="py-12 bg-white">
        <div className="container mx-auto px-4 animate-on-scroll" id="volunteers-section">
          <h1 className={`text-4xl md:text-5xl font-bold text-center text-accent mb-4 ${animatedItems.includes('volunteers-section') ? 'animate-fadeIn' : 'opacity-0'}`}>
            I Volontari
          </h1>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-10 rounded-full"></div>
          <div className={`text-lg text-gray-700 text-left max-w-4xl mx-auto leading-relaxed ${animatedItems.includes('volunteers-section') ? 'animate-slideUp delay-300' : 'opacity-0 translate-y-10'}`}>
            <p>
              La mission dei volontari della nostra associazione è offrire presenza, ascolto e sostegno umano a chi
              affronta un percorso di cura particolarmente impegnativo. Diventare volontario significa scegliere di
              mettere a disposizione il proprio tempo o le proprie competenze senza obblighi né compiti fissi, nel
              pieno rispetto del{' '}
              <button
                onClick={() => setIsVademecumModalOpen(true)}
                className="text-accent font-semibold underline hover:text-accent/80 transition-colors cursor-pointer"
              >
                vademecum del volontario
              </button>
              , che rispecchia i nostri principi. Un sorriso, un aiuto
              pratico o un'esperienza professionale da condividere: ogni contributo è prezioso. Diventare
              volontario significa partecipare a un progetto di solidarietà flessibile e profondamente arricchente.
            </p>
          </div>
        </div>
      </div>
      {/* Call to Action */}
      <div className="container mx-auto px-4 mt-16 mb-12 animate-on-scroll" id="cta-section">
        <div className={`bg-gradient-to-r from-primary via-accent to-accent text-white rounded-xl shadow-2xl overflow-hidden relative py-12 px-6 text-center max-w-4xl mx-auto transform transition-all duration-500 hover:shadow-[0_10px_40px_rgba(0,0,0,0.3)] ${animatedItems.includes('cta-section') ? 'animate-fadeIn' : 'opacity-0'}`}>
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
            <div className="absolute -top-12 -left-12 w-64 h-64 rounded-full bg-white opacity-10 animate-pulse"></div>
            <div className="absolute top-40 -right-16 w-48 h-48 rounded-full bg-white opacity-10 animate-float"></div>
            <div className="absolute bottom-0 left-1/4 w-32 h-32 rounded-full bg-white opacity-10 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6 relative animate-slideUp">Unisciti a Noi</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto relative animate-slideUp" style={{ animationDelay: '200ms' }}>
            Diventa volontario e scopri da vicino la realtà dei pazienti grazie anche ai nostri corsi!
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
            <a
              href="/contatti"
              className="group bg-transparent border-2 border-white text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:bg-white hover:text-accent hover:border-transparent hover:translate-y-[-5px] hover:shadow-xl"
            >
              <span className="relative z-10">Contattaci</span>
            </a>
          </div>
        </div>
      </div>
      <div className="py-12 bg-gray-50">
        {/* Header Section */}
        <div className="container mx-auto px-4 mb-12 animate-on-scroll" id="header-section">
          <h1 className={`text-4xl md:text-5xl font-bold text-center text-accent mb-4 ${animatedItems.includes('header-section') ? 'animate-fadeIn' : 'opacity-0'}`}>Consiglio Direttivo</h1>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-8 rounded-full"></div>
          <p className={`text-xl text-gray-700 text-center max-w-3xl mx-auto ${animatedItems.includes('header-section') ? 'animate-slideUp delay-300' : 'opacity-0 translate-y-10'}`}>
            Il Consiglio Direttivo dell'Associazione è composto da medici, genitori di pazienti ed ex pazienti che hanno esperienza diretta con malattie ematologiche rare. Tutti i consiglieri, volontariamente, si impegnano per realizzare gli obiettivi dell'Associazione, operando in armonia con la struttura che la ospita e con le altre organizzazioni di volontariato. Le decisioni sull' operato dell'Associazione vengono prese collegialmente.
          </p>
        </div>

        {/* Board Members Grid */}
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {boardMembers.map((member, index) => (
              <div
                key={member.id}
                id={`member-${member.id}`}
                className={`bg-white rounded-xl shadow-xl overflow-hidden animate-on-scroll transform transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 group flex flex-col ${animatedItems.includes(`member-${member.id}`) ? 'animate-fadeInUp' : 'opacity-0 translate-y-10'}`}
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="relative h-64">
                  {member.profileImage ? (
                    <img
                      src={member.profileImage}
                      alt={member.name}
                      className="w-full h-full object-cover"
                      style={member.imagePosition ? { objectPosition: member.imagePosition } : {}}
                    />
                  ) : (
                    <div
                      className="w-full h-full flex items-center justify-center overflow-hidden"
                      style={{ backgroundColor: member.color }}
                    >
                      {/* Background patterns */}
                      <div className="absolute inset-0 opacity-10">
                        <div className="absolute w-60 h-60 rounded-full border-4 border-white/30 -top-20 -left-20"></div>
                        <div className="absolute w-40 h-40 rounded-full border-4 border-white/30 bottom-10 right-10"></div>
                      </div>

                      {/* Main geometric shape */}
                      <div
                        className="w-36 h-36 bg-white/30 flex items-center justify-center backdrop-blur-sm group-hover:scale-110 group-hover:rotate-12 transition-all duration-700 z-10"
                        style={{
                          clipPath: index % 3 === 0 ? 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' :
                            index % 3 === 1 ? 'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)' :
                              'circle(50% at 50% 50%)'
                        }}
                      >
                        <div className="w-28 h-28 flex items-center justify-center" style={{
                          backgroundColor: `${member.color}`,
                          clipPath: index % 3 === 0 ? 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' :
                            index % 3 === 1 ? 'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)' :
                              'circle(50% at 50% 50%)'
                        }}>
                          <svg className="w-12 h-12 text-white transform transition-all duration-500 group-hover:rotate-45" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d={member.icon} />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="absolute top-0 right-0 m-4 bg-white/20 backdrop-blur-sm p-2 transition-all duration-300 hover:bg-white/40 hover:scale-110"
                        style={{
                          clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)'
                        }}>
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                    </div>
                  )}
                  {/* Overlay con Nome e Ruolo (questo blocco rimane invariato e fuori dalla condizione if/else) */}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent py-4 px-6">
                    <h3 className="text-xl font-bold text-white group-hover:translate-x-2 transition-transform duration-300">{member.name}</h3>
                    <p className="text-white/80 text-sm">{member.role}</p>
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <p className="text-gray-600 leading-relaxed">{member.bio}</p>
                  <div className="mt-auto flex justify-end pt-4">
                    <button
                      onClick={() => setSelectedMember(member)}
                      className="bg-green-600 text-white py-2 px-5 rounded-lg text-sm font-semibold hover:bg-green-700 transition-all duration-300 ease-in-out shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                    >
                      Leggi di più
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Values Section */}
        <div className="container mx-auto px-4 mt-16 animate-on-scroll" id="values-section">
          <h2 className={`text-3xl font-bold text-center text-accent mb-4 ${animatedItems.includes('values-section') ? 'animate-fadeIn' : 'opacity-0'}`}>I Nostri Valori</h2>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-8 rounded-full"></div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
            <div className="bg-white p-6 rounded-lg shadow text-center transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110">
                <svg className="w-10 h-10 text-primary" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-primary">Empatia</h3>
              <p className="text-gray-600">Cerchiamo di comprendere i bisogni dei pazienti e delle loro famiglie, con l'obiettivo di offrire conforto e speranza a chi attraversa momenti difficili.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow text-center transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110">
                <svg className="w-10 h-10 text-primary" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"> {/* Consider changing SVG if desired */}
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-primary">Solidarietà</h3>
              <p className="text-gray-600">Operiamo con generosità e disponibilità, rispettando la dignità di ogni persona, affinchè nessun paziente resti indietro.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow text-center transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <div className="w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110">
                <svg className="w-10 h-10 text-accent" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"> {/* Consider changing SVG if desired */}
                  <path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-accent">Dedizione</h3>
              <p className="text-gray-600">Ci impegnamo per trovare nuove soluzioni utili a migliorare la qualità della vita dei pazienti e delle loro famiglie.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow text-center transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <div className="w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 group-hover:scale-110">
                <svg className="w-10 h-10 text-accent" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M10 12a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zM3 10a7 7 0 1114 0 7 7 0 01-14 0z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-accent">Trasparenza</h3>
              <p className="text-gray-600">Operiamo con onestà e integrità in tutte le nostre attività e comunicazioni.</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}


        {/* Scientific Committee Section */}
        <div className="container mx-auto px-4 mt-16 mb-12 animate-on-scroll" id="scientific-committee-section">
          <h2 className={`text-3xl font-bold text-center text-accent mb-4 ${animatedItems.includes('scientific-committee-section') ? 'animate-fadeIn' : 'opacity-0'}`}>
            Il Comitato Scientifico
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-8 rounded-full"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col h-full">
              <div className="flex-1 flex flex-col items-center">
                <img
                  src={martelli_img}
                  alt="Prof. Maurizio Martelli"
                  className="w-48 h-48 object-cover rounded-full mb-4"
                />
                <h3 className="text-xl font-bold text-primary text-center mb-2">Prof. Maurizio Martelli</h3>
                <p className="text-gray-600 text-center">Professore ordinario, Dipartimento di Medicina Traslazionale e di Precisione, Sapienza Università di Roma, Direttore UOC Ematologia, DAI Ematologia, Oncologia e Dermatologia AOU Policlinico Umberto I Via Benevento 6, 00161 Roma</p>
              </div>
              <div className="mt-6">
                <button onClick={handleDownloadCV} className="w-full bg-accent text-white py-2 rounded hover:bg-accent/90 transition-colors">
                  Scarica CV
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col h-full">
              <div className="flex-1 flex flex-col items-center">
                <img
                  src={breccia_img}
                  alt="Prof. Massimo Breccia"
                  className="w-48 h-48 object-cover rounded-full mb-4"
                />
                <h3 className="text-xl font-bold text-primary text-center mb-2">Prof. Massimo Breccia</h3>
                <p className="text-gray-600 text-center">Professore associato, Dipartimento di Medicina Traslazionale e di Precisione, Sapienza Università di Roma, Responsabile UOS Day Hospital ematologico UOC Ematologia DAI Ematologia, Oncologia e Dermatologia AOU Policlinico Umberto I Via Benevento 6, 00161 Roma</p>
              </div>
              <div className="mt-6">
                <button onClick={handleDownloadCV2} className="w-full bg-accent text-white py-2 rounded hover:bg-accent/90 transition-colors">
                  Scarica CV
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col h-full">
              <div className="flex-1 flex flex-col items-center">
                <img
                  src={annaTestiImg}
                  alt="Dott.ssa Anna Maria Testi"
                  className="w-48 h-48 object-cover rounded-full mb-4"
                />
                <h3 className="text-xl font-bold text-primary text-center mb-2">Dott.ssa Anna Maria Testi</h3>
                <p className="text-gray-600 text-center">Ematologa, Esperta in leucemie acute pediatriche</p>
              </div>
              <div className="mt-6">
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col h-full">
              <div className="flex-1 flex flex-col items-center">
                <img
                  src={barberi_img}
                  alt="Prof. Walter Barberi"
                  className="w-48 h-48 object-cover rounded-full mb-4"
                />
                <h3 className="text-xl font-bold text-primary text-center mb-2">Prof. Walter Barberi</h3>
                <p className="text-gray-600 text-center">Dirigente Medico UOC Ematologia, Programma Trapianti DAI Ematologia, Oncologia e Dermatologia AOU Policlinico Umberto I, Via Benevento 6, 00161 Roma</p>
              </div>
              <div className="mt-6">
                <button onClick={handleDownloadCV3} className="w-full bg-accent text-white py-2 rounded hover:bg-accent/90 transition-colors">
                  Scarica CV
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col h-full">
              <div className="flex-1 flex flex-col items-center">
                <img
                  src={palumbo_img}
                  alt="Dott.ssa Giovanna Palumbo"
                  className="w-48 h-48 object-cover rounded-full mb-4"
                />
                <h3 className="text-xl font-bold text-primary text-center mb-2">Dott.ssa Giovanna Palumbo</h3>
                <p className="text-gray-600 text-center">Dirigente Medico UOC Ematologia DAI Ematologia, Oncologia e Dermatologia AOU Policlinico Umberto I, Via Benevento 6, 00161 Roma</p>
              </div>
              <div className="mt-6">
                <button onClick={handleDownloadCV4} className="w-full bg-accent text-white py-2 rounded hover:bg-accent/90 transition-colors">
                  Scarica CV
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col h-full">
              <div className="flex-1 flex flex-col items-center">
                <img
                  src="https://via.placeholder.com/450"
                  className="w-48 h-48 object-cover rounded-full mb-4"
                />
                <h3 className="text-xl font-bold text-primary text-center mb-2">Dott.ssa Michela Ribersani</h3>
                <p className="text-gray-600 text-center">Dirigente Medico UOC Ematologia DAI Ematologia, Oncologia e Dermatologia AOU Policlinico Umberto I, Via Benevento 6, 00161 Roma</p>
              </div>
              <div className="mt-6">
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col h-full">
              <div className="flex-1 flex flex-col items-center">
                <img
                  src={montanari_img}
                  alt="Dott.ssa Marta Montanari"
                  className="w-48 h-48 object-cover rounded-full mb-4"
                />
                <h3 className="text-xl font-bold text-primary text-center mb-2">Dott.ssa Marta Montanari</h3>
                <p className="text-gray-600 text-center">Coordinatrice infermieristica UOC Ematologia, Terapie innovative DAI Ematologia, Oncologia e Dermatologia AOU Policlinico Umberto I Via Benevento 6, 00161 Roma Tel 06/49974730</p>
              </div>
            </div>
          </div>
        </div>

        {/* Corsi di aggiornamento Section */}
        {/* <div className="container mx-auto px-4 mt-16 mb-12 animate-on-scroll" id="training-courses-section">
          <h2 className={`text-3xl font-bold text-center text-accent mb-4 ${animatedItems.includes('training-courses-section') ? 'animate-fadeIn' : 'opacity-0'}`}>
            Corsi di aggiornamento
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-primary via-accent to-accent mx-auto mb-8 rounded-full"></div>

          <div className="max-w-4xl mx-auto text-left space-y-6">
            <div className="text-center mb-8">
              <p className="text-gray-500 font-medium">25 ottobre 2025</p>
              <h3 className="text-xl text-primary font-semibold italic mt-2">Corso di formazione per volontarie e volontari</h3>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mt-2 uppercase">ESSERE VOLONTARIE e VOLONTARI in EMATOLOGIA</h2>
            </div>

            <p className="text-gray-700 leading-relaxed">
              <strong>Il 25 ottobre 2025 si è tenuto il primo corso di formazione per volontarie e volontari in Ematologia</strong>, un percorso pensato per preparare chi desidera offrire il proprio tempo ai pazienti e alle loro famiglie, all’interno della UOC di Ematologia dell’AOU Policlinico Umberto I, diretta dal <strong>Prof. Maurizio Martelli</strong>.
            </p>

            <p className="text-gray-700 leading-relaxed">
              Il corso è nato dalla necessità di fornire ai volontari strumenti concreti e competenze relazionali adeguate a un reparto complesso come quello ematologico, dove ogni giorno si affrontano malattie come leucemie, linfomi, mieloma e altre malattie rare e si gestiscono percorsi di cura intensivi, come la chemioterapia e il trapianto di cellule staminali.
            </p>

            <blockquote className="border-l-4 border-accent pl-4 italic text-gray-700 my-6 bg-gray-50 p-4 rounded-r-lg">
              “Essere volontari non significa solo “dare una mano”. Significa esserci davvero: ascoltare, accogliere, camminare accanto a chi sta affrontando un momento difficile. Il volontariato è fatto di tempo, ascolto e presenza. Ma anche di preparazione, cura e rispetto. Per questo nasce il nostro corso di formazione, un percorso che unisce conoscenze mediche essenziali e attenzione alla dimensione umana.”
              <footer className="text-sm font-semibold text-gray-600 mt-2 not-italic">— ha esordito la Presidente, dott.ssa Fiorina Giona, presentando il corso.</footer>
            </blockquote>

            <p className="text-gray-700 leading-relaxed">
              Durante l’incontro si sono approfondite le aree tematiche fondamentali per poter iniziare il percorso di volontariato:
            </p>

            <div className="space-y-6">
              <div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">1. Conoscere il reparto e i propri compiti: un reparto complesso, un ruolo prezioso</h4>
                <p className="text-gray-700 leading-relaxed">
                  I volontari sono stati edotti sulla struttura e sulle modalità organizzative dell’Ematologia, sottolineandone la caratteristica di luogo dove ogni giorno si intrecciano cura, ricerca e speranza. Sono stati, inoltre, informati sulle norme che regolano la loro attività: obbligo del tesserino, registrazione delle presenze, rispetto del segreto professionale e osservanza del codice deontologico.
                </p>
              </div>

              <div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">2. Conoscere le principali patologie ematologiche: capire le malattie per capire le persone</h4>
                <p className="text-gray-700 leading-relaxed">
                  Grazie alla guida della Dott.ssa Anna Maria Testi, i partecipanti hanno ricevuto informazioni semplici ed essenziali sulle principali malattie del sangue—leucemie, linfomi, mieloma—e i percorsi di cura più frequenti, come la chemioterapia o il trapianto di cellule staminali, utili per comprendere meglio il contesto clinico e il vissuto dei pazienti. Non per diventare esperti, ma per saper stare accanto con maggiore consapevolezza.
                </p>
              </div>

              <div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">3. Imparare a comunicare con empatia: La forza delle relazioni</h4>
                <p className="text-gray-700 leading-relaxed">
                  Una parte fondamentale della formazione è stata dedicata alla comunicazione. La Dott.ssa Silvia Finocchi ha affrontato il tema della comunicazione consapevole in reparto: dall’ascolto attivo alla gestione del silenzio, dalla sensibilità emotiva al ruolo cruciale della comunicazione non verbale. Ogni gesto, ogni parola—perfino il silenzio—ha un significato. Il volontario impara, così, a guardare la persona oltre la malattia, a rispettare i tempi, le emozioni e i silenzi. A essere una presenza calma, empatica, capace di creare un piccolo spazio di serenità.
                </p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <h4 className="text-lg font-bold text-gray-800 mb-2">Un primo passo, insieme</h4>
              <p className="text-gray-700 leading-relaxed">
                Questo corso è l’inizio di un cammino: un modo per prepararsi, per crescere e per donare il proprio tempo nel modo più rispettoso e umano possibile. Perché il volontariato, in fondo, è una relazione. Ed è lì che fa la differenza.
              </p>
            </div>
          </div>
        </div> */}
      </div>

      {/* Modal per i dettagli del membro */}
      {selectedMember && (
        <Modal
          isOpen={!!selectedMember}
          onClose={() => setSelectedMember(null)}
          title={selectedMember.name}
        >
          <div className="text-gray-700 space-y-4">
            <p><strong>Ruolo:</strong> {selectedMember.role}</p>
            <p><strong>Mansione:</strong> {selectedMember.bio}</p>
            <hr className="my-4" />
            <p>{selectedMember.didascalia}</p>
          </div>
        </Modal>
      )}

      {/* Modal per il Vademecum del Volontario */}
      <PdfModal
        isOpen={isVademecumModalOpen}
        onClose={() => setIsVademecumModalOpen(false)}
        title="Vademecum del Volontario"
        pdfUrl={vademecumVolontarioPdf}
      />
    </>
  );
};

export default ConsiglioDirectivo;
